<!-- Mobile View (existing) -->
<header class="app-header mobile-view">
  <div class="left">
    <span class="header-title">{{ title || 'Passports' }}</span>
  </div>
  <div class="right">
    <button type="button" class="icon-button" (click)="onRefreshClick()" [class.spin]="ui.refreshing()" aria-label="Refresh">
      <img class="icon" src="/assets/images/Refresh.png" alt="Refresh">
    </button>
    <button *ngIf="showSearchIcon" class="icon-button" type="button" (click)="onToggleSearch()">
      <img class="icon" [src]="searchSelected ? '/assets/images/Selected_Search.png' : '/assets/images/Search.png'" alt="Search">
    </button>
    <button *ngIf="showFilterIcon" class="icon-button" type="button" (click)="onToggleFilter()">
      <img class="icon" [src]="filterSelected ? '/assets/images/Selected_Filter.png' : '/assets/images/Filter.png'" alt="Filter">
    </button>
    <button type="button" class="icon-button comments-wrapper" (click)="onCommentsClick()">
      <img class="icon" src="/assets/images/Comments_Icon.png" alt="Comments">
      <span class="badge" *ngIf="notificationsCount > 0" [attr.data-count]="notificationsCount">{{ notificationsCount }}</span>
    </button>
  </div>
</header>

<!-- Desktop View -->
<header class="app-header desktop-view" 
        [class.comments-open]="showCommentsPanel || showHistoryPanel"
        [class.notifications-open]="showCommentsNotificationsPanel">
  <div class="desktop-left">
    <img class="desktop-header-logo" src="/assets/images/Logo.png" alt="McCain Logo">
    <span class="desktop-header-title">Digital Passports</span>
  </div>
  <div class="desktop-right">
    <div class="desktop-nav-buttons-group">
      <button type="button" 
              class="desktop-nav-button" 
              [class.selected]="activeTab === 'home'"
              (click)="onDesktopNavClick('home')">
        <img class="desktop-nav-icon" 
             [src]="activeTab === 'home' ? '/assets/images/Home_Selected.png' : '/assets/images/Home_Unselected.png'" 
             alt="Homepage"
             width="30" 
             height="30">
        <span class="desktop-nav-text">Homepage</span>
      </button>
      <button type="button" 
              class="desktop-nav-button" 
              [class.selected]="activeTab === 'contacts'"
              (click)="onDesktopNavClick('contacts')">
        <img class="desktop-nav-icon" 
             [src]="activeTab === 'contacts' ? '/assets/images/Contact_Selected.png' : '/assets/images/Contact_Unselected.png'" 
             alt="Contacts"
             width="30" 
             height="30">
        <span class="desktop-nav-text">Contacts</span>
      </button>
      <button type="button" 
              class="desktop-nav-button" 
              [class.selected]="activeTab === 'profile'"
              (click)="onDesktopNavClick('profile')">
        <img class="desktop-nav-icon" 
             [src]="activeTab === 'profile' ? '/assets/images/Person_Selected.png' : '/assets/images/Person_Unselected.png'" 
             alt="Profile"
             width="30" 
             height="30">
        <span class="desktop-nav-text">Profile</span>
      </button>
    </div>
    <button type="button" 
            class="desktop-comments-button" 
            [class.active]="showCommentsNotificationsPanel"
            (click)="onCommentsClick()">
      <img class="desktop-comments-icon" 
           [src]="showCommentsNotificationsPanel ? '/assets/images/Comments_Icon_Black.png' : '/assets/images/Comments_Icon_Yellow.png'" 
           alt="Comments" 
           width="30" 
           height="30">
      <span class="desktop-comments-badge" *ngIf="notificationsCount > 0">{{ notificationsCount }}</span>
    </button>
  </div>
</header>

<!-- Desktop Comments Notifications Panel Overlay -->
<button type="button" class="desktop-comments-overlay notifications-overlay" *ngIf="showCommentsNotificationsPanel" (click)="closeCommentsNotificationsPanel()" aria-label="Close comments notifications panel"></button>
<div class="desktop-comments-panel" *ngIf="showCommentsNotificationsPanel">
  <app-comments-notifications></app-comments-notifications>
</div>

<!-- Desktop Passport Comments Panel Overlay -->
<button type="button" class="desktop-comments-overlay" *ngIf="showCommentsPanel" (click)="closeCommentsPanel()" aria-label="Close comments panel"></button>
<div class="desktop-passport-comments-panel" *ngIf="showCommentsPanel">
  <app-comments [passportId]="commentsPassportId" [header]="commentsHeader" [readOnly]="commentsReadOnly" (closed)="closeCommentsPanel()"></app-comments>
</div>

<!-- Desktop Passport History Panel Overlay -->
<button type="button" class="desktop-comments-overlay" *ngIf="showHistoryPanel" (click)="closeHistoryPanel()" aria-label="Close history panel"></button>
<div class="desktop-passport-history-panel" *ngIf="showHistoryPanel">
  <app-history [passportId]="historyPassportId" [header]="historyHeader" (closed)="closeHistoryPanel()"></app-history>
</div>

<!-- Desktop Filters/Search Bar (below header) -->
<div class="desktop-filters-search-wrapper" *ngIf="showDesktopFilters">
  <div class="desktop-filters-search-container">
    <h1 class="desktop-passports-heading">Passports</h1>
    <div class="desktop-filters-search-row">
      <div class="desktop-filters-group">
        <div class="desktop-filter" *ngFor="let f of filterDefinitions">
          <button class="desktop-filter-box" 
               [class.filter-active]="(filterService.filters()[f.id] || []).length > 0"
               (click)="$event.stopPropagation(); openId = openId === f.id ? '' : f.id"
               (keydown.enter)="$event.stopPropagation(); openId = openId === f.id ? '' : f.id"
               (keydown.space)="$event.stopPropagation(); $event.preventDefault(); openId = openId === f.id ? '' : f.id"
               type="button">
            <span class="desktop-filter-label">{{ f.label }} - </span>
            <span class="desktop-filter-value">{{ getFilterDisplayValue(f.id) }}</span>
            <img class="desktop-filter-chevron" src="/assets/images/Chevron_Left.png" alt="open">
            <div class="desktop-dropdown-panel" *ngIf="openId === f.id" 
                 (click)="$event.stopPropagation()"
                 (keydown)="$event.stopPropagation()"
                 role="menu">
              <div class="desktop-dropdown-search-row">
                <label class="sr-only" [attr.for]="'desktop-filter-search-' + f.id">Search {{ f.label }}</label>
                <input class="desktop-dropdown-search"
                       [attr.id]="'desktop-filter-search-' + f.id"
                       type="text"
                       placeholder="Search"
                       [(ngModel)]="dropdownSearch">
                <button class="desktop-dropdown-close" type="button" (click)="openId=''; dropdownSearch=''">×</button>
              </div>
              <div class="desktop-dropdown-options">
                <label class="desktop-option-row desktop-select-all" *ngIf="!dropdownSearch">
                  <input type="checkbox" [checked]="isAllVisibleSelected(f)" (change)="onToggleSelectAll(f)">
                  <span>Select all</span>
                </label>
                <label class="desktop-option-row" *ngFor="let opt of f.options" [style.display]="!dropdownSearch || opt.toLowerCase().includes(dropdownSearch.toLowerCase()) ? 'flex' : 'none'">
                  <input type="checkbox" [checked]="(filterService.filters()[f.id] || []).includes(opt)" (change)="filterService.toggleValue(f.id, opt)">
                  <span>{{ opt }}</span>
                </label>
              </div>
            </div>
          </button>
        </div>
      </div>
      <div class="desktop-filters-clear" *ngIf="hasActiveFilters()">
        <button type="button"
                class="clear-all-btn"
                aria-label="Clear all filters"
                (click)="$event.stopPropagation(); onClearAllFilters()">
          Clear All
        </button>
      </div>
      <div class="desktop-search-box">
        <input class="desktop-search-input" type="text" placeholder="Search Passports" aria-label="Search Passports" [ngModel]="searchService.query()" (ngModelChange)="searchService.setQuery($event)">
        <img class="desktop-search-icon" src="/assets/images/Search_Bar_Icon.png" alt="Search" width="20" height="20">
      </div>
    </div>
  </div>
</div>

<div class="search-bar-wrapper" *ngIf="searchSelected">
  <div class="search-bar">
    <input class="search-input" type="text" placeholder="Search Passports" aria-label="Search Passports" [ngModel]="searchService.query()" (ngModelChange)="searchService.setQuery($event)">
    <img class="search-input-icon" src="/assets/images/Search_Bar_Icon.png" alt="Search" width="16" height="16">
  </div>
  
</div>

<div class="filters-wrapper" *ngIf="filterSelected">
  <div class="filters">
    <div class="filter" *ngFor="let f of filterDefinitions">
      <button class="filter-box" 
           [class.filter-active]="(filterService.filters()[f.id] || []).length > 0"
           (click)="$event.stopPropagation(); openId = openId === f.id ? '' : f.id"
           (keydown.enter)="$event.stopPropagation(); openId = openId === f.id ? '' : f.id"
           (keydown.space)="$event.stopPropagation(); $event.preventDefault(); openId = openId === f.id ? '' : f.id"
           type="button">
        <label class="sr-only" [attr.for]="'filter-input-' + f.id">{{ f.label }} filter</label>
        <input class="filter-input"
               [attr.id]="'filter-input-' + f.id"
               type="text"
               [placeholder]="'Select ' + f.label"
               [value]="(filterService.filters()[f.id] || []).join(', ')"
               readonly>
        <img class="filter-chevron" src="/assets/images/Filters_Chevron_Icon.png" alt="open">
        <div class="dropdown-panel" *ngIf="openId === f.id" 
             (click)="$event.stopPropagation()"
             (keydown)="$event.stopPropagation()"
             role="menu">
          <div class="dropdown-search-row">
            <label class="sr-only" [attr.for]="'mobile-filter-search-' + f.id">Search {{ f.label }}</label>
            <input class="dropdown-search"
                   [attr.id]="'mobile-filter-search-' + f.id"
                   type="text"
                   placeholder="Search"
                   [(ngModel)]="dropdownSearch">
            <button class="dropdown-close" type="button" (click)="openId=''; dropdownSearch=''">×</button>
          </div>
          <div class="dropdown-options">
            <label class="option-row select-all" *ngIf="!dropdownSearch">
              <input type="checkbox" [checked]="isAllVisibleSelected(f)" (change)="onToggleSelectAll(f)">
              <span>Select all</span>
            </label>
            <label class="option-row" *ngFor="let opt of f.options" [style.display]="!dropdownSearch || opt.toLowerCase().includes(dropdownSearch.toLowerCase()) ? 'flex' : 'none'">
              <input type="checkbox" [checked]="(filterService.filters()[f.id] || []).includes(opt)" (change)="filterService.toggleValue(f.id, opt)">
              <span>{{ opt }}</span>
            </label>
          </div>
        </div>
      </button>
      <div class="selected-chips" *ngIf="(filterService.filters()[f.id] || []).length">
        <span class="chip" *ngFor="let v of filterService.filters()[f.id]">
          {{ v }}
          <button type="button" (click)="filterService.toggleValue(f.id, v)">×</button>
        </span>
      </div>
    </div>
    <div class="filters-actions">
      <button class="clear-all-btn" type="button" (click)="onClearAllFilters()">Clear All</button>
    </div>
  </div>
</div>


